// Generated by purs version 0.14.3
"use strict";
var Control_Applicative = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Control/Applicative.purs");
var Control_Bind = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Control/Bind.purs");
var Control_Monad_Except = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/transformers/v5.2.0/src/Control/Monad/Except.purs");
var Control_Monad_Except_Trans = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/transformers/v5.2.0/src/Control/Monad/Except/Trans.purs");
var Data_Either = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/either/v5.0.0/src/Data/Either.purs");
var Data_Eq = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Data/Eq.purs");
var Data_Foldable = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/foldable-traversable/v5.0.1/src/Data/Foldable.purs");
var Data_Functor = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Data/Functor.purs");
var Data_Generic_Rep = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Data/Generic/Rep.purs");
var Data_Identity = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/identity/v5.0.0/src/Data/Identity.purs");
var Data_List_Types = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/lists/v6.0.1/src/Data/List/Types.purs");
var Data_Map_Internal = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/ordered-collections/v2.0.1/src/Data/Map/Internal.purs");
var Data_Maybe = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/maybe/v5.0.0/src/Data/Maybe.purs");
var Data_Ord = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Data/Ord.purs");
var Data_Show = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Data/Show.purs");
var Data_Show_Generic = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Data/Show/Generic.purs");
var Data_String_CodePoints = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/strings/v5.0.0/src/Data/String/CodePoints.purs");
var Data_Symbol = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Data/Symbol.purs");
var Data_Traversable = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/foldable-traversable/v5.0.1/src/Data/Traversable.purs");
var Data_Tuple = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/tuples/v6.0.1/src/Data/Tuple.purs");
var Data_Unfoldable = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/unfoldable/v5.0.0/src/Data/Unfoldable.purs");
var Foreign = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/foreign/v6.0.1/src/Foreign.purs");
var Foreign_Generic = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/foreign-generic/v11.0.0/src/Foreign/Generic.purs");
var Foreign_Generic_Class = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/foreign-generic/v11.0.0/src/Foreign/Generic/Class.purs");
var Foreign_Index = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/foreign/v6.0.1/src/Foreign/Index.purs");
var Foreign_Keys = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/foreign/v6.0.1/src/Foreign/Keys.purs");
var Foreign_Object = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/foreign-object/v3.0.0/src/Foreign/Object.purs");
var Option = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/option/v9.0.0/src/Option.purs");
var Partial_Unsafe = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/partial/v3.0.0/src/Partial/Unsafe.purs");
var Simple_JSON = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/simple-json/v8.0.0/src/Simple/JSON.purs");
var View = (function () {
    function View() {

    };
    View.value = new View();
    return View;
})();
var Hide = (function () {
    function Hide() {

    };
    Hide.value = new Hide();
    return Hide;
})();
var Ask = (function () {
    function Ask() {

    };
    Ask.value = new Ask();
    return Ask;
})();
var PPR = function (x) {
    return x;
};
var Pre = (function () {
    function Pre(value0) {
        this.value0 = value0;
    };
    Pre.create = function (value0) {
        return new Pre(value0);
    };
    return Pre;
})();
var PrePost = (function () {
    function PrePost(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    PrePost.create = function (value0) {
        return function (value1) {
            return new PrePost(value0, value1);
        };
    };
    return PrePost;
})();
var Leaf = (function () {
    function Leaf(value0) {
        this.value0 = value0;
    };
    Leaf.create = function (value0) {
        return new Leaf(value0);
    };
    return Leaf;
})();
var All = (function () {
    function All(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    All.create = function (value0) {
        return function (value1) {
            return new All(value0, value1);
        };
    };
    return All;
})();
var Any = (function () {
    function Any(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Any.create = function (value0) {
        return function (value1) {
            return new Any(value0, value1);
        };
    };
    return Any;
})();
var Not = (function () {
    function Not(value0) {
        this.value0 = value0;
    };
    Not.create = function (value0) {
        return new Not(value0);
    };
    return Not;
})();
var Soft = (function () {
    function Soft() {

    };
    Soft.value = new Soft();
    return Soft;
})();
var Hard = (function () {
    function Hard() {

    };
    Hard.value = new Hard();
    return Hard;
})();
var ForD3 = function (x) {
    return x;
};
var DPTerse = (function () {
    function DPTerse() {

    };
    DPTerse.value = new DPTerse();
    return DPTerse;
})();
var DPNormal = (function () {
    function DPNormal() {

    };
    DPNormal.value = new DPNormal();
    return DPNormal;
})();
var DPVerbose = (function () {
    function DPVerbose() {

    };
    DPVerbose.value = new DPVerbose();
    return DPVerbose;
})();
var QoutJS = function (x) {
    return x;
};
var Default = function (x) {
    return x;
};
var Marking = function (x) {
    return x;
};
var StdinSchema = (function () {
    function StdinSchema(value0) {
        this.value0 = value0;
    };
    StdinSchema.create = function (value0) {
        return new StdinSchema(value0);
    };
    return StdinSchema;
})();
var And = (function () {
    function And() {

    };
    And.value = new And();
    return And;
})();
var Or = (function () {
    function Or() {

    };
    Or.value = new Or();
    return Or;
})();
var Simply = (function () {
    function Simply(value0) {
        this.value0 = value0;
    };
    Simply.create = function (value0) {
        return new Simply(value0);
    };
    return Simply;
})();
var Q = function (x) {
    return x;
};
var readDefault = function (dictMonad) {
    return function (dictIndexable) {
        return function (dictIndex) {
            return function (fm) {
                return function (mk) {
                    return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(dictMonad))(Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(dictMonad))(Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(dictMonad))(Foreign_Index.ix(dictIndexable)(dictIndex)(fm)(mk))(Foreign_Index.readProp(dictMonad)("source")))(Foreign.readString(dictMonad)))(function (source) {
                        return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(dictMonad))(Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(dictMonad))(Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(dictMonad))(Foreign_Index.ix(dictIndexable)(dictIndex)(fm)(mk))(Foreign_Index.readProp(dictMonad)("value")))(Foreign.readString(dictMonad)))(function (value) {
                            var mb = (function () {
                                if (value === "true") {
                                    return new Data_Maybe.Just(true);
                                };
                                if (value === "false") {
                                    return new Data_Maybe.Just(false);
                                };
                                if (value === "undefined") {
                                    return Data_Maybe.Nothing.value;
                                };
                                return Data_Maybe.Nothing.value;
                            })();
                            var lr = (function () {
                                if (source === "default") {
                                    return Data_Either.Left.create;
                                };
                                if (source === "user") {
                                    return Data_Either.Right.create;
                                };
                                return Data_Either.Left.create;
                            })();
                            return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(dictMonad))(new Data_Tuple.Tuple(mk, lr(mb)));
                        });
                    });
                };
            };
        };
    };
};
var mkQ = function (sv) {
    return function (ao) {
        return function (nl) {
            return function (pp) {
                return function (m) {
                    return function (c) {
                        return {
                            shouldView: sv,
                            andOr: ao,
                            tagNL: nl,
                            prePost: pp,
                            mark: m,
                            children: c
                        };
                    };
                };
            };
        };
    };
};
var maybe2string = function (dictShow) {
    return function (v) {
        if (v instanceof Data_Maybe.Just) {
            return Data_Show.show(dictShow)(v.value0);
        };
        if (v instanceof Data_Maybe.Nothing) {
            return "undefined";
        };
        throw new Error("Failed pattern match at AnyAll.Types (line 246, column 1 - line 246, column 31): " + [ v.constructor.name ]);
    };
};
var markup = function (x) {
    return Marking(Data_Functor.map(Data_Map_Internal.functorMap)(Default)(x));
};
var label2pre = function (v) {
    if (v instanceof Pre) {
        return v.value0;
    };
    if (v instanceof PrePost) {
        return v.value0;
    };
    throw new Error("Failed pattern match at AnyAll.Types (line 79, column 1 - line 79, column 22): " + [ v.constructor.name ]);
};
var label2post = function (v) {
    if (v instanceof PrePost) {
        return v.value1;
    };
    if (v instanceof Pre) {
        return "";
    };
    throw new Error("Failed pattern match at AnyAll.Types (line 82, column 1 - line 82, column 29): " + [ v.constructor.name ]);
};
var getMarking = function (v) {
    return v;
};
var genericStdinSchema = new Data_Generic_Rep.Generic(function (x) {
    return x.value0;
}, function (x) {
    return new StdinSchema(x);
});
var genericShouldView = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof View) {
        return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
    };
    if (x instanceof Hide) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
    };
    if (x instanceof Ask) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value));
    };
    throw new Error("Failed pattern match at AnyAll.Types (line 252, column 1 - line 252, column 58): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return View.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
        return Hide.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
        return Ask.value;
    };
    throw new Error("Failed pattern match at AnyAll.Types (line 252, column 1 - line 252, column 58): " + [ x.constructor.name ]);
});
var showShouldView = new Data_Show.Show(function (eta) {
    return Data_Show_Generic.genericShow(genericShouldView)(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
        return "View";
    })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
        return "Hide";
    })))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
        return "Ask";
    })))))(eta);
});
var genericQoutJS = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var genericQ = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var genericPrePostRecord = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var showPrePostRecord = new Data_Show.Show(function (eta) {
    return Data_Show_Generic.genericShow(genericPrePostRecord)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Option.showOptionOption()(Option.showOptionCons(new Data_Symbol.IsSymbol(function () {
        return "post";
    }))(Data_Show.showString)(Option.showOptionCons(new Data_Symbol.IsSymbol(function () {
        return "pre";
    }))(Data_Show.showString)(Option.showOptionNil)())())))(new Data_Symbol.IsSymbol(function () {
        return "PPR";
    })))(eta);
});
var showQoutJS = new Data_Show.Show(function (eta) {
    return Data_Show_Generic.genericShow(genericQoutJS)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Option.showOptionOption()(Option.showOptionCons(new Data_Symbol.IsSymbol(function () {
        return "andOr";
    }))(Option.showOptionOption()(Option.showOptionCons(new Data_Symbol.IsSymbol(function () {
        return "children";
    }))(Data_Show.showArray(showQoutJS))(Option.showOptionCons(new Data_Symbol.IsSymbol(function () {
        return "contents";
    }))(Data_Show.showString)(Option.showOptionCons(new Data_Symbol.IsSymbol(function () {
        return "nl";
    }))(Foreign_Object.showObject(Data_Show.showString))(Option.showOptionCons(new Data_Symbol.IsSymbol(function () {
        return "tag";
    }))(Data_Show.showString)(Option.showOptionNil)())())())()))(Option.showOptionCons(new Data_Symbol.IsSymbol(function () {
        return "mark";
    }))(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "source";
    }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "value";
    }))(Data_Show.showRecordFieldsNil)(Data_Show.showString))(Data_Show.showString)))(Option.showOptionCons(new Data_Symbol.IsSymbol(function () {
        return "post";
    }))(Data_Show.showString)(Option.showOptionCons(new Data_Symbol.IsSymbol(function () {
        return "prePost";
    }))(showPrePostRecord)(Option.showOptionCons(new Data_Symbol.IsSymbol(function () {
        return "shouldView";
    }))(Data_Show.showString)(Option.showOptionNil)())())())())())))(new Data_Symbol.IsSymbol(function () {
        return "QoutJS";
    })))(eta);
});
var genericMarking = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var genericLabel = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof Pre) {
        return new Data_Generic_Rep.Inl(x.value0);
    };
    if (x instanceof PrePost) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Product(x.value0, x.value1));
    };
    throw new Error("Failed pattern match at AnyAll.Types (line 69, column 1 - line 69, column 52): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return new Pre(x.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr) {
        return new PrePost(x.value0.value0, x.value0.value1);
    };
    throw new Error("Failed pattern match at AnyAll.Types (line 69, column 1 - line 69, column 52): " + [ x.constructor.name ]);
});
var showLabel = function (dictShow) {
    return new Data_Show.Show(Data_Show_Generic.genericShow(genericLabel)(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(dictShow))(new Data_Symbol.IsSymbol(function () {
        return "Pre";
    })))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow))(Data_Show_Generic.genericShowArgsArgument(dictShow)))(new Data_Symbol.IsSymbol(function () {
        return "PrePost";
    })))));
};
var genericItem = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof Leaf) {
        return new Data_Generic_Rep.Inl(x.value0);
    };
    if (x instanceof All) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, x.value1)));
    };
    if (x instanceof Any) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, x.value1))));
    };
    if (x instanceof Not) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0)));
    };
    throw new Error("Failed pattern match at AnyAll.Types (line 44, column 1 - line 44, column 50): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return new Leaf(x.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
        return new All(x.value0.value0.value0, x.value0.value0.value1);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
        return new Any(x.value0.value0.value0.value0, x.value0.value0.value0.value1);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inr)) {
        return new Not(x.value0.value0.value0);
    };
    throw new Error("Failed pattern match at AnyAll.Types (line 44, column 1 - line 44, column 50): " + [ x.constructor.name ]);
});
var showItem = function (dictShow) {
    return new Data_Show.Show(function (eta) {
        return Data_Show_Generic.genericShow(genericItem)(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(dictShow))(new Data_Symbol.IsSymbol(function () {
            return "Leaf";
        })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(showLabel(dictShow)))(Data_Show_Generic.genericShowArgsArgument(Data_Show.showArray(showItem(dictShow)))))(new Data_Symbol.IsSymbol(function () {
            return "All";
        })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(showLabel(dictShow)))(Data_Show_Generic.genericShowArgsArgument(Data_Show.showArray(showItem(dictShow)))))(new Data_Symbol.IsSymbol(function () {
            return "Any";
        })))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(showItem(dictShow)))(new Data_Symbol.IsSymbol(function () {
            return "Not";
        }))))))(eta);
    });
};
var genericHardness = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof Soft) {
        return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
    };
    if (x instanceof Hard) {
        return new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value);
    };
    throw new Error("Failed pattern match at AnyAll.Types (line 289, column 1 - line 289, column 54): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return Soft.value;
    };
    if (x instanceof Data_Generic_Rep.Inr) {
        return Hard.value;
    };
    throw new Error("Failed pattern match at AnyAll.Types (line 289, column 1 - line 289, column 54): " + [ x.constructor.name ]);
});
var showHardness = new Data_Show.Show(Data_Show_Generic.genericShow(genericHardness)(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "Soft";
})))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "Hard";
})))));
var genericForD3 = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var showForD3 = new Data_Show.Show(function (eta) {
    return Data_Show_Generic.genericShow(genericForD3)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "children";
    }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "name";
    }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "value";
    }))(Data_Show.showRecordFieldsNil)(Data_Show.showInt))(Data_Show.showString))(Data_Show.showArray(showForD3)))))(new Data_Symbol.IsSymbol(function () {
        return "ForD3";
    })))(eta);
});
var genericDisplayPref = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof DPTerse) {
        return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
    };
    if (x instanceof DPNormal) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
    };
    if (x instanceof DPVerbose) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value));
    };
    throw new Error("Failed pattern match at AnyAll.Types (line 277, column 1 - line 277, column 60): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return DPTerse.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
        return DPNormal.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
        return DPVerbose.value;
    };
    throw new Error("Failed pattern match at AnyAll.Types (line 277, column 1 - line 277, column 60): " + [ x.constructor.name ]);
});
var showDisplayPref = new Data_Show.Show(Data_Show_Generic.genericShow(genericDisplayPref)(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "DPTerse";
})))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "DPNormal";
})))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
    return "DPVerbose";
}))))));
var genericDefault = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var showDefault = function (dictShow) {
    return new Data_Show.Show(Data_Show_Generic.genericShow(genericDefault)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Either.showEither(Data_Maybe.showMaybe(dictShow))(Data_Maybe.showMaybe(dictShow))))(new Data_Symbol.IsSymbol(function () {
        return "Default";
    }))));
};
var showMarking = Data_Map_Internal.showMap(Data_Show.showString)(showDefault(Data_Show.showBoolean));
var showStdinSchema = function (dictShow) {
    return new Data_Show.Show(Data_Show_Generic.genericShow(genericStdinSchema)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "andOrTree";
    }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "marking";
    }))(Data_Show.showRecordFieldsNil)(showMarking))(showItem(dictShow)))))(new Data_Symbol.IsSymbol(function () {
        return "StdinSchema";
    }))));
};
var genericAndOr = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof And) {
        return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
    };
    if (x instanceof Or) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
    };
    if (x instanceof Simply) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0));
    };
    throw new Error("Failed pattern match at AnyAll.Types (line 265, column 1 - line 265, column 52): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return And.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
        return Or.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
        return new Simply(x.value0.value0);
    };
    throw new Error("Failed pattern match at AnyAll.Types (line 265, column 1 - line 265, column 52): " + [ x.constructor.name ]);
});
var showAndOr = function (dictShow) {
    return new Data_Show.Show(Data_Show_Generic.genericShow(genericAndOr)(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
        return "And";
    })))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
        return "Or";
    })))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(dictShow))(new Data_Symbol.IsSymbol(function () {
        return "Simply";
    }))))));
};
var showQ = new Data_Show.Show(function (eta) {
    return Data_Show_Generic.genericShow(genericQ)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "andOr";
    }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "children";
    }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "mark";
    }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "prePost";
    }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "shouldView";
    }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "tagNL";
    }))(Data_Show.showRecordFieldsNil)(Data_Map_Internal.showMap(Data_Show.showString)(Data_Show.showString)))(showShouldView))(Data_Maybe.showMaybe(showLabel(Data_Show.showString))))(showDefault(Data_Show.showBoolean)))(Data_Show.showArray(showQ)))(showAndOr(Data_Show.showString)))))(new Data_Symbol.IsSymbol(function () {
        return "Q";
    })))(eta);
});
var forD3 = function (lang) {
    return function (v) {
        var shorten = function (n) {
            return function (x) {
                var $210 = Data_String_CodePoints.length(x) > n;
                if ($210) {
                    return Data_String_CodePoints.take(n - 3 | 0)(x) + "...";
                };
                return x;
            };
        };
        var getNL = function (x) {
            var v1 = Data_Map_Internal.lookup(Data_Ord.ordString)(lang)(v.tagNL);
            if (v1 instanceof Data_Maybe.Nothing) {
                return x;
            };
            if (v1 instanceof Data_Maybe.Just) {
                return x + (". " + v1.value0);
            };
            throw new Error("Failed pattern match at AnyAll.Types (line 362, column 13 - line 364, column 31): " + [ v1.constructor.name ]);
        };
        var qName = (function () {
            if (v.andOr instanceof And) {
                return Data_Maybe.maybe("all of")(label2pre)(v.prePost);
            };
            if (v.andOr instanceof Or) {
                return Data_Maybe.maybe("any of")(label2pre)(v.prePost);
            };
            if (v.andOr instanceof Simply) {
                return shorten(45)(getNL(v.andOr.value0));
            };
            throw new Error("Failed pattern match at AnyAll.Types (line 358, column 11 - line 361, column 39): " + [ v.andOr.constructor.name ]);
        })();
        return {
            name: qName,
            children: Data_Functor.map(Data_Functor.functorArray)(forD3(lang))(v.children),
            value: 100
        };
    };
};
var eqShouldView = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof View && y instanceof View) {
            return true;
        };
        if (x instanceof Hide && y instanceof Hide) {
            return true;
        };
        if (x instanceof Ask && y instanceof Ask) {
            return true;
        };
        return false;
    };
});
var eqPrePostRecord = new Data_Eq.Eq(function (x) {
    return function (y) {
        return Data_Eq.eq(Option.eqOptionOption(Option.eqOptionCons(new Data_Symbol.IsSymbol(function () {
            return "post";
        }))(Data_Eq.eqString)(Option.eqOptionCons(new Data_Symbol.IsSymbol(function () {
            return "pre";
        }))(Data_Eq.eqString)(Option.eqOptionNil)())())())(x)(y);
    };
});
var eqQoutJS = new Data_Eq.Eq(function (x) {
    return function (y) {
        return Data_Eq.eq(Option.eqOptionOption(Option.eqOptionCons(new Data_Symbol.IsSymbol(function () {
            return "andOr";
        }))(Option.eqOptionOption(Option.eqOptionCons(new Data_Symbol.IsSymbol(function () {
            return "children";
        }))(Data_Eq.eqArray(eqQoutJS))(Option.eqOptionCons(new Data_Symbol.IsSymbol(function () {
            return "contents";
        }))(Data_Eq.eqString)(Option.eqOptionCons(new Data_Symbol.IsSymbol(function () {
            return "nl";
        }))(Foreign_Object.eqObject(Data_Eq.eqString))(Option.eqOptionCons(new Data_Symbol.IsSymbol(function () {
            return "tag";
        }))(Data_Eq.eqString)(Option.eqOptionNil)())())())())())(Option.eqOptionCons(new Data_Symbol.IsSymbol(function () {
            return "mark";
        }))(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(new Data_Symbol.IsSymbol(function () {
            return "value";
        }))(Data_Eq.eqString))()(new Data_Symbol.IsSymbol(function () {
            return "source";
        }))(Data_Eq.eqString)))(Option.eqOptionCons(new Data_Symbol.IsSymbol(function () {
            return "post";
        }))(Data_Eq.eqString)(Option.eqOptionCons(new Data_Symbol.IsSymbol(function () {
            return "prePost";
        }))(eqPrePostRecord)(Option.eqOptionCons(new Data_Symbol.IsSymbol(function () {
            return "shouldView";
        }))(Data_Eq.eqString)(Option.eqOptionNil)())())())())())())(x)(y);
    };
});
var eqLabel = function (dictEq) {
    return new Data_Eq.Eq(function (x) {
        return function (y) {
            if (x instanceof Pre && y instanceof Pre) {
                return Data_Eq.eq(dictEq)(x.value0)(y.value0);
            };
            if (x instanceof PrePost && y instanceof PrePost) {
                return Data_Eq.eq(dictEq)(x.value0)(y.value0) && Data_Eq.eq(dictEq)(x.value1)(y.value1);
            };
            return false;
        };
    });
};
var eqItem = function (dictEq) {
    return new Data_Eq.Eq(function (x) {
        return function (y) {
            if (x instanceof Leaf && y instanceof Leaf) {
                return Data_Eq.eq(dictEq)(x.value0)(y.value0);
            };
            if (x instanceof All && y instanceof All) {
                return Data_Eq.eq(eqLabel(dictEq))(x.value0)(y.value0) && Data_Eq.eq(Data_Eq.eqArray(eqItem(dictEq)))(x.value1)(y.value1);
            };
            if (x instanceof Any && y instanceof Any) {
                return Data_Eq.eq(eqLabel(dictEq))(x.value0)(y.value0) && Data_Eq.eq(Data_Eq.eqArray(eqItem(dictEq)))(x.value1)(y.value1);
            };
            if (x instanceof Not && y instanceof Not) {
                return Data_Eq.eq(eqItem(dictEq))(x.value0)(y.value0);
            };
            return false;
        };
    });
};
var eqHardness = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof Soft && y instanceof Soft) {
            return true;
        };
        if (x instanceof Hard && y instanceof Hard) {
            return true;
        };
        return false;
    };
});
var eqForD3 = new Data_Eq.Eq(function (x) {
    return function (y) {
        return Data_Eq.eq(Data_Eq.eqArray(eqForD3))(x.children)(y.children) && x.name === y.name && x.value === y.value;
    };
});
var eqDisplayPref = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof DPTerse && y instanceof DPTerse) {
            return true;
        };
        if (x instanceof DPNormal && y instanceof DPNormal) {
            return true;
        };
        if (x instanceof DPVerbose && y instanceof DPVerbose) {
            return true;
        };
        return false;
    };
});
var eqDefault = function (dictEq) {
    return new Data_Eq.Eq(function (x) {
        return function (y) {
            return Data_Eq.eq(Data_Either.eqEither(Data_Maybe.eqMaybe(dictEq))(Data_Maybe.eqMaybe(dictEq)))(x)(y);
        };
    });
};
var eqMarking = new Data_Eq.Eq(function (x) {
    return function (y) {
        return Data_Eq.eq(Data_Map_Internal.eqMap(Data_Eq.eqString)(eqDefault(Data_Eq.eqBoolean)))(x)(y);
    };
});
var eqStdinSchema = function (dictEq) {
    return new Data_Eq.Eq(function (x) {
        return function (y) {
            return Data_Eq.eq(eqItem(dictEq))(x.value0.andOrTree)(y.value0.andOrTree) && Data_Eq.eq(eqMarking)(x.value0.marking)(y.value0.marking);
        };
    });
};
var eqAndOr = function (dictEq) {
    return new Data_Eq.Eq(function (x) {
        return function (y) {
            if (x instanceof And && y instanceof And) {
                return true;
            };
            if (x instanceof Or && y instanceof Or) {
                return true;
            };
            if (x instanceof Simply && y instanceof Simply) {
                return Data_Eq.eq(dictEq)(x.value0)(y.value0);
            };
            return false;
        };
    });
};
var eqQ = new Data_Eq.Eq(function (x) {
    return function (y) {
        return Data_Eq.eq(eqAndOr(Data_Eq.eqString))(x.andOr)(y.andOr) && Data_Eq.eq(Data_Eq.eqArray(eqQ))(x.children)(y.children) && Data_Eq.eq(eqDefault(Data_Eq.eqBoolean))(x.mark)(y.mark) && Data_Eq.eq(Data_Maybe.eqMaybe(eqLabel(Data_Eq.eqString)))(x.prePost)(y.prePost) && Data_Eq.eq(eqShouldView)(x.shouldView)(y.shouldView) && Data_Eq.eq(Data_Map_Internal.eqMap(Data_Eq.eqString)(Data_Eq.eqString))(x.tagNL)(y.tagNL);
    };
});
var encodeShouldView = new Foreign_Generic_Class.Encode(function (eta) {
    return Foreign_Generic.genericEncode(genericShouldView)(Foreign_Generic_Class.genericEncodeSum(Foreign_Generic_Class.genericEncodeConstructor(new Data_Symbol.IsSymbol(function () {
        return "View";
    }))(Foreign_Generic_Class.genericEncodeArgsNoArguments))(Foreign_Generic_Class.genericEncodeSum(Foreign_Generic_Class.genericEncodeConstructor(new Data_Symbol.IsSymbol(function () {
        return "Hide";
    }))(Foreign_Generic_Class.genericEncodeArgsNoArguments))(Foreign_Generic_Class.genericEncodeConstructor(new Data_Symbol.IsSymbol(function () {
        return "Ask";
    }))(Foreign_Generic_Class.genericEncodeArgsNoArguments))))(Foreign_Generic_Class.defaultOptions)(eta);
});
var encodePrePostRecord = new Foreign_Generic_Class.Encode(function (eta) {
    return Foreign.unsafeToForeign(eta);
});
var encodeLabel = function (dictEncode) {
    return new Foreign_Generic_Class.Encode(function (eta) {
        return Foreign_Generic.genericEncode(genericLabel)(Foreign_Generic_Class.genericEncodeSum(Foreign_Generic_Class.genericEncodeConstructor(new Data_Symbol.IsSymbol(function () {
            return "Pre";
        }))(Foreign_Generic_Class.genericEncodeArgsArgument(Foreign_Generic_Class.encodeWithOptionsOther(dictEncode))))(Foreign_Generic_Class.genericEncodeConstructor(new Data_Symbol.IsSymbol(function () {
            return "PrePost";
        }))(Foreign_Generic_Class.genericEncodeArgsProduct(Foreign_Generic_Class.genericEncodeArgsArgument(Foreign_Generic_Class.encodeWithOptionsOther(dictEncode)))(Foreign_Generic_Class.genericEncodeArgsArgument(Foreign_Generic_Class.encodeWithOptionsOther(dictEncode))))))(Foreign_Generic_Class.defaultOptions)(eta);
    });
};
var encodeItem = function (dictEncode) {
    return new Foreign_Generic_Class.Encode(function (eta) {
        return Foreign_Generic.genericEncode(genericItem)(Foreign_Generic_Class.genericEncodeSum(Foreign_Generic_Class.genericEncodeConstructor(new Data_Symbol.IsSymbol(function () {
            return "Leaf";
        }))(Foreign_Generic_Class.genericEncodeArgsArgument(Foreign_Generic_Class.encodeWithOptionsOther(dictEncode))))(Foreign_Generic_Class.genericEncodeSum(Foreign_Generic_Class.genericEncodeConstructor(new Data_Symbol.IsSymbol(function () {
            return "All";
        }))(Foreign_Generic_Class.genericEncodeArgsProduct(Foreign_Generic_Class.genericEncodeArgsArgument(Foreign_Generic_Class.encodeWithOptionsOther(encodeLabel(dictEncode))))(Foreign_Generic_Class.genericEncodeArgsArgument(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.arrayEncode(encodeItem(dictEncode)))))))(Foreign_Generic_Class.genericEncodeSum(Foreign_Generic_Class.genericEncodeConstructor(new Data_Symbol.IsSymbol(function () {
            return "Any";
        }))(Foreign_Generic_Class.genericEncodeArgsProduct(Foreign_Generic_Class.genericEncodeArgsArgument(Foreign_Generic_Class.encodeWithOptionsOther(encodeLabel(dictEncode))))(Foreign_Generic_Class.genericEncodeArgsArgument(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.arrayEncode(encodeItem(dictEncode)))))))(Foreign_Generic_Class.genericEncodeConstructor(new Data_Symbol.IsSymbol(function () {
            return "Not";
        }))(Foreign_Generic_Class.genericEncodeArgsArgument(Foreign_Generic_Class.encodeWithOptionsOther(encodeItem(dictEncode))))))))(Foreign_Generic_Class.defaultOptions)(eta);
    });
};
var encodeHardness = new Foreign_Generic_Class.Encode(function (eta) {
    return Foreign_Generic.genericEncode(genericHardness)(Foreign_Generic_Class.genericEncodeSum(Foreign_Generic_Class.genericEncodeConstructor(new Data_Symbol.IsSymbol(function () {
        return "Soft";
    }))(Foreign_Generic_Class.genericEncodeArgsNoArguments))(Foreign_Generic_Class.genericEncodeConstructor(new Data_Symbol.IsSymbol(function () {
        return "Hard";
    }))(Foreign_Generic_Class.genericEncodeArgsNoArguments)))(Foreign_Generic_Class.defaultOptions)(eta);
});
var encodeForD3 = new Foreign_Generic_Class.Encode(function (eta) {
    return Foreign.unsafeToForeign(eta);
});
var encodeDisplayPref = new Foreign_Generic_Class.Encode(function (eta) {
    return Foreign_Generic.genericEncode(genericDisplayPref)(Foreign_Generic_Class.genericEncodeSum(Foreign_Generic_Class.genericEncodeConstructor(new Data_Symbol.IsSymbol(function () {
        return "DPTerse";
    }))(Foreign_Generic_Class.genericEncodeArgsNoArguments))(Foreign_Generic_Class.genericEncodeSum(Foreign_Generic_Class.genericEncodeConstructor(new Data_Symbol.IsSymbol(function () {
        return "DPNormal";
    }))(Foreign_Generic_Class.genericEncodeArgsNoArguments))(Foreign_Generic_Class.genericEncodeConstructor(new Data_Symbol.IsSymbol(function () {
        return "DPVerbose";
    }))(Foreign_Generic_Class.genericEncodeArgsNoArguments))))(Foreign_Generic_Class.defaultOptions)(eta);
});
var encodeAndOr = function (dictEncode) {
    return new Foreign_Generic_Class.Encode(function (eta) {
        return Foreign_Generic.genericEncode(genericAndOr)(Foreign_Generic_Class.genericEncodeSum(Foreign_Generic_Class.genericEncodeConstructor(new Data_Symbol.IsSymbol(function () {
            return "And";
        }))(Foreign_Generic_Class.genericEncodeArgsNoArguments))(Foreign_Generic_Class.genericEncodeSum(Foreign_Generic_Class.genericEncodeConstructor(new Data_Symbol.IsSymbol(function () {
            return "Or";
        }))(Foreign_Generic_Class.genericEncodeArgsNoArguments))(Foreign_Generic_Class.genericEncodeConstructor(new Data_Symbol.IsSymbol(function () {
            return "Simply";
        }))(Foreign_Generic_Class.genericEncodeArgsArgument(Foreign_Generic_Class.encodeWithOptionsOther(dictEncode))))))(Foreign_Generic_Class.defaultOptions)(eta);
    });
};
var dumpPrePost = function (v) {
    if (v instanceof Data_Maybe.Just && v.value0 instanceof Pre) {
        return PPR(Option.fromRecord(Option.fromRecordAny(Option.fromRecordOptionCons(new Data_Symbol.IsSymbol(function () {
            return "pre";
        }))(Option.fromRecordOptionNil)()()())(Option.fromRecordRequiredNil)()()())({
            pre: v.value0.value0
        }));
    };
    if (v instanceof Data_Maybe.Just && v.value0 instanceof PrePost) {
        return PPR(Option.fromRecord(Option.fromRecordAny(Option.fromRecordOptionCons(new Data_Symbol.IsSymbol(function () {
            return "post";
        }))(Option.fromRecordOptionCons(new Data_Symbol.IsSymbol(function () {
            return "pre";
        }))(Option.fromRecordOptionNil)()()())()()())(Option.fromRecordRequiredNil)()()())({
            pre: v.value0.value0,
            post: v.value0.value1
        }));
    };
    if (v instanceof Data_Maybe.Nothing) {
        return PPR(Option.empty);
    };
    throw new Error("Failed pattern match at AnyAll.Types (line 241, column 1 - line 241, column 53): " + [ v.constructor.name ]);
};
var dumpDefault = function (dictShow) {
    return function (v) {
        if (v instanceof Data_Either.Left) {
            return {
                source: "default",
                value: maybe2string(dictShow)(v.value0)
            };
        };
        if (v instanceof Data_Either.Right) {
            return {
                source: "user",
                value: maybe2string(dictShow)(v.value0)
            };
        };
        throw new Error("Failed pattern match at AnyAll.Types (line 138, column 1 - line 138, column 62): " + [ v.constructor.name ]);
    };
};
var encodeDefault = function (dictShow) {
    return function (dictEncode) {
        return new Foreign_Generic_Class.Encode(function (eta) {
            return Foreign_Generic_Class.encode(Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)(new Data_Symbol.IsSymbol(function () {
                return "value";
            }))(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))(new Data_Symbol.IsSymbol(function () {
                return "source";
            }))(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))(dumpDefault(dictShow)(eta));
        });
    };
};
var encodeMarking = new Foreign_Generic_Class.Encode(function (v) {
    return Foreign.unsafeToForeign(Foreign_Object.fromFoldable(Data_List_Types.foldableList)(Data_Map_Internal.toUnfoldable(Data_List_Types.unfoldableList)(Data_Functor.map(Data_Map_Internal.functorMap)(dumpDefault(Data_Show.showBoolean))(v))));
});
var encodeStdinSchema = function (dictShow) {
    return function (dictEncode) {
        return new Foreign_Generic_Class.Encode(function (eta) {
            return Foreign_Generic.genericEncode(genericStdinSchema)(Foreign_Generic_Class.genericEncodeConstructor(new Data_Symbol.IsSymbol(function () {
                return "StdinSchema";
            }))(Foreign_Generic_Class.genericEncodeArgsArgument(Foreign_Generic_Class.encodeWithOptionsRecord()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)(new Data_Symbol.IsSymbol(function () {
                return "marking";
            }))(Foreign_Generic_Class.encodeWithOptionsOther(encodeMarking)))(new Data_Symbol.IsSymbol(function () {
                return "andOrTree";
            }))(Foreign_Generic_Class.encodeWithOptionsOther(encodeItem(dictEncode)))))))(Foreign_Generic_Class.defaultOptions)(eta);
        });
    };
};
var qoutjs = function (v) {
    var miniNL = Foreign_Object.fromFoldable(Data_Foldable.foldableArray)(Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray)(v.tagNL));
    return QoutJS(Option.fromRecord(Option.fromRecordAny(Option.fromRecordOptionCons(new Data_Symbol.IsSymbol(function () {
        return "andOr";
    }))(Option.fromRecordOptionCons(new Data_Symbol.IsSymbol(function () {
        return "mark";
    }))(Option.fromRecordOptionCons(new Data_Symbol.IsSymbol(function () {
        return "prePost";
    }))(Option.fromRecordOptionCons(new Data_Symbol.IsSymbol(function () {
        return "shouldView";
    }))(Option.fromRecordOptionNil)()()())()()())()()())()()())(Option.fromRecordRequiredNil)()()())({
        shouldView: Data_Show.show(showShouldView)(v.shouldView),
        andOr: (function () {
            if (v.andOr instanceof And) {
                return Option.fromRecord(Option.fromRecordAny(Option.fromRecordOptionCons(new Data_Symbol.IsSymbol(function () {
                    return "children";
                }))(Option.fromRecordOptionCons(new Data_Symbol.IsSymbol(function () {
                    return "nl";
                }))(Option.fromRecordOptionCons(new Data_Symbol.IsSymbol(function () {
                    return "tag";
                }))(Option.fromRecordOptionNil)()()())()()())()()())(Option.fromRecordRequiredNil)()()())({
                    tag: "All",
                    children: Data_Functor.map(Data_Functor.functorArray)(qoutjs)(v.children),
                    nl: miniNL
                });
            };
            if (v.andOr instanceof Or) {
                return Option.fromRecord(Option.fromRecordAny(Option.fromRecordOptionCons(new Data_Symbol.IsSymbol(function () {
                    return "children";
                }))(Option.fromRecordOptionCons(new Data_Symbol.IsSymbol(function () {
                    return "nl";
                }))(Option.fromRecordOptionCons(new Data_Symbol.IsSymbol(function () {
                    return "tag";
                }))(Option.fromRecordOptionNil)()()())()()())()()())(Option.fromRecordRequiredNil)()()())({
                    tag: "Any",
                    children: Data_Functor.map(Data_Functor.functorArray)(qoutjs)(v.children),
                    nl: miniNL
                });
            };
            if (v.andOr instanceof Simply) {
                return Option.fromRecord(Option.fromRecordAny(Option.fromRecordOptionConsMaybe(new Data_Symbol.IsSymbol(function () {
                    return "contents";
                }))(Option.fromRecordOptionCons(new Data_Symbol.IsSymbol(function () {
                    return "nl";
                }))(Option.fromRecordOptionCons(new Data_Symbol.IsSymbol(function () {
                    return "tag";
                }))(Option.fromRecordOptionNil)()()())()()())()()())(Option.fromRecordRequiredNil)()()())({
                    tag: "Leaf",
                    contents: new Data_Maybe.Just(v.andOr.value0),
                    nl: miniNL
                });
            };
            throw new Error("Failed pattern match at AnyAll.Types (line 216, column 14 - line 223, column 12): " + [ v.andOr.constructor.name ]);
        })(),
        prePost: dumpPrePost(v.prePost),
        mark: dumpDefault(Data_Show.showBoolean)(v.mark)
    }));
};
var decodeMarking = new Foreign_Generic_Class.Decode(function (fm) {
    return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign_Keys.keys(Data_Identity.monadIdentity)(fm))(function (mkeys) {
        return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Data_Traversable.sequence(Data_Traversable.traversableArray)(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(Data_Functor.map(Data_Functor.functorArray)(readDefault(Data_Identity.monadIdentity)(Foreign_Index.indexableForeign(Data_Identity.monadIdentity))(Foreign_Index.indexString(Data_Identity.monadIdentity))(fm))(mkeys)))(function (astuples) {
            return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(markup(Data_Map_Internal.fromFoldable(Data_Ord.ordString)(Data_Foldable.foldableArray)(astuples)));
        });
    });
});
var decodeLabel = function (dictDecode) {
    return new Foreign_Generic_Class.Decode(function (eta) {
        return Foreign_Generic.genericDecode(genericLabel)(Foreign_Generic_Class.genericDecodeSum(Foreign_Generic_Class.genericDecodeConstructor(new Data_Symbol.IsSymbol(function () {
            return "Pre";
        }))(Foreign_Generic_Class.genericDecodeArgsArgument(Foreign_Generic_Class.decodeWithOptionsOther(dictDecode)))(Foreign_Generic_Class.genericCountArgsArgument))(Foreign_Generic_Class.genericDecodeConstructor(new Data_Symbol.IsSymbol(function () {
            return "PrePost";
        }))(Foreign_Generic_Class.genericDecodeArgsProduct(Foreign_Generic_Class.genericDecodeArgsArgument(Foreign_Generic_Class.decodeWithOptionsOther(dictDecode)))(Foreign_Generic_Class.genericDecodeArgsArgument(Foreign_Generic_Class.decodeWithOptionsOther(dictDecode))))(Foreign_Generic_Class.genericCountArgsProduct(Foreign_Generic_Class.genericCountArgsArgument)(Foreign_Generic_Class.genericCountArgsArgument))))(Foreign_Generic_Class.defaultOptions)(eta);
    });
};
var decodeItem = function (dictDecode) {
    return new Foreign_Generic_Class.Decode(function (eta) {
        return Foreign_Generic.genericDecode(genericItem)(Foreign_Generic_Class.genericDecodeSum(Foreign_Generic_Class.genericDecodeConstructor(new Data_Symbol.IsSymbol(function () {
            return "Leaf";
        }))(Foreign_Generic_Class.genericDecodeArgsArgument(Foreign_Generic_Class.decodeWithOptionsOther(dictDecode)))(Foreign_Generic_Class.genericCountArgsArgument))(Foreign_Generic_Class.genericDecodeSum(Foreign_Generic_Class.genericDecodeConstructor(new Data_Symbol.IsSymbol(function () {
            return "All";
        }))(Foreign_Generic_Class.genericDecodeArgsProduct(Foreign_Generic_Class.genericDecodeArgsArgument(Foreign_Generic_Class.decodeWithOptionsOther(decodeLabel(dictDecode))))(Foreign_Generic_Class.genericDecodeArgsArgument(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.arrayDecode(decodeItem(dictDecode))))))(Foreign_Generic_Class.genericCountArgsProduct(Foreign_Generic_Class.genericCountArgsArgument)(Foreign_Generic_Class.genericCountArgsArgument)))(Foreign_Generic_Class.genericDecodeSum(Foreign_Generic_Class.genericDecodeConstructor(new Data_Symbol.IsSymbol(function () {
            return "Any";
        }))(Foreign_Generic_Class.genericDecodeArgsProduct(Foreign_Generic_Class.genericDecodeArgsArgument(Foreign_Generic_Class.decodeWithOptionsOther(decodeLabel(dictDecode))))(Foreign_Generic_Class.genericDecodeArgsArgument(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.arrayDecode(decodeItem(dictDecode))))))(Foreign_Generic_Class.genericCountArgsProduct(Foreign_Generic_Class.genericCountArgsArgument)(Foreign_Generic_Class.genericCountArgsArgument)))(Foreign_Generic_Class.genericDecodeConstructor(new Data_Symbol.IsSymbol(function () {
            return "Not";
        }))(Foreign_Generic_Class.genericDecodeArgsArgument(Foreign_Generic_Class.decodeWithOptionsOther(decodeItem(dictDecode))))(Foreign_Generic_Class.genericCountArgsArgument)))))(Foreign_Generic_Class.defaultOptions)(eta);
    });
};
var decodeIt = function (f) {
    return Data_Either.either(function (e) {
        return Partial_Unsafe.unsafeCrashWith("error while decoding Item: " + Data_Show.show(Data_List_Types.showNonEmptyList(Foreign.showForeignError))(e));
    })(function (v) {
        return v;
    })(Control_Monad_Except.runExcept(Foreign_Generic_Class.decode(decodeItem(Foreign_Generic_Class.stringDecode))(f)));
};
var decodeHardness = new Foreign_Generic_Class.Decode(function (eta) {
    return Foreign_Generic.genericDecode(genericHardness)(Foreign_Generic_Class.genericDecodeSum(Foreign_Generic_Class.genericDecodeConstructor(new Data_Symbol.IsSymbol(function () {
        return "Soft";
    }))(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(Foreign_Generic_Class.genericDecodeConstructor(new Data_Symbol.IsSymbol(function () {
        return "Hard";
    }))(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments)))(Foreign_Generic_Class.defaultOptions)(eta);
});
var d3_tag = (function () {
    var $282 = Simple_JSON.writeJSON(Simple_JSON.writeForeignForeign);
    var $283 = Foreign_Generic_Class.encode(encodeForD3);
    var $284 = forD3("");
    return function ($285) {
        return $282($283($284($285)));
    };
})();
var d3_en = (function () {
    var $286 = Simple_JSON.writeJSON(Simple_JSON.writeForeignForeign);
    var $287 = Foreign_Generic_Class.encode(encodeForD3);
    var $288 = forD3("en");
    return function ($289) {
        return $286($287($288($289)));
    };
})();
module.exports = {
    Leaf: Leaf,
    All: All,
    Any: Any,
    Not: Not,
    decodeIt: decodeIt,
    Pre: Pre,
    PrePost: PrePost,
    label2pre: label2pre,
    label2post: label2post,
    Marking: Marking,
    readDefault: readDefault,
    markup: markup,
    getMarking: getMarking,
    Default: Default,
    dumpDefault: dumpDefault,
    Q: Q,
    mkQ: mkQ,
    QoutJS: QoutJS,
    qoutjs: qoutjs,
    PPR: PPR,
    dumpPrePost: dumpPrePost,
    maybe2string: maybe2string,
    View: View,
    Hide: Hide,
    Ask: Ask,
    And: And,
    Or: Or,
    Simply: Simply,
    DPTerse: DPTerse,
    DPNormal: DPNormal,
    DPVerbose: DPVerbose,
    Soft: Soft,
    Hard: Hard,
    StdinSchema: StdinSchema,
    ForD3: ForD3,
    forD3: forD3,
    d3_tag: d3_tag,
    d3_en: d3_en,
    eqItem: eqItem,
    genericItem: genericItem,
    showItem: showItem,
    encodeItem: encodeItem,
    decodeItem: decodeItem,
    eqLabel: eqLabel,
    genericLabel: genericLabel,
    showLabel: showLabel,
    encodeLabel: encodeLabel,
    decodeLabel: decodeLabel,
    eqMarking: eqMarking,
    genericMarking: genericMarking,
    showMarking: showMarking,
    encodeMarking: encodeMarking,
    decodeMarking: decodeMarking,
    eqDefault: eqDefault,
    genericDefault: genericDefault,
    showDefault: showDefault,
    encodeDefault: encodeDefault,
    eqQ: eqQ,
    genericQ: genericQ,
    showQ: showQ,
    eqQoutJS: eqQoutJS,
    genericQoutJS: genericQoutJS,
    showQoutJS: showQoutJS,
    eqPrePostRecord: eqPrePostRecord,
    genericPrePostRecord: genericPrePostRecord,
    showPrePostRecord: showPrePostRecord,
    encodePrePostRecord: encodePrePostRecord,
    eqShouldView: eqShouldView,
    genericShouldView: genericShouldView,
    showShouldView: showShouldView,
    encodeShouldView: encodeShouldView,
    eqAndOr: eqAndOr,
    genericAndOr: genericAndOr,
    showAndOr: showAndOr,
    encodeAndOr: encodeAndOr,
    eqDisplayPref: eqDisplayPref,
    genericDisplayPref: genericDisplayPref,
    showDisplayPref: showDisplayPref,
    encodeDisplayPref: encodeDisplayPref,
    eqHardness: eqHardness,
    genericHardness: genericHardness,
    showHardness: showHardness,
    encodeHardness: encodeHardness,
    decodeHardness: decodeHardness,
    eqStdinSchema: eqStdinSchema,
    genericStdinSchema: genericStdinSchema,
    showStdinSchema: showStdinSchema,
    encodeStdinSchema: encodeStdinSchema,
    eqForD3: eqForD3,
    genericForD3: genericForD3,
    showForD3: showForD3,
    encodeForD3: encodeForD3
};

